import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-municipio',
  templateUrl: './municipio.component.html',
  styleUrls: ['./municipio.component.scss']
})
export class MunicipioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
